import type { MemberAuthenticationToken } from '@vista-digital/ocapi-types/v1'
import { mobileEmbedService } from '../mobileEmbed.service'

export const useMobileEmbedToken = () => {
    const getMobileAppToken = (): MemberAuthenticationToken | undefined => {
        return mobileEmbedService.MemberToken
    }

    const updateMobileAppToken = () => {
        // Throw an exception so user doesn't get signed out hopefully
        throw new Error('Member token expired in embed view.')
    }

    return { getMobileAppToken, updateMobileAppToken }
}
